import { get } from 'lodash';
import { createSelector } from 'reselect';
import { AB_KEY } from './constants';
import {
    PROFILE_1N_COMMUNITY_LABEL_SHOWN,
    PROFILE_1N_EDUCATION_YEARS_SHOWN,
    PROFILE_1N_INSTITUTES_SHOWN,
    PROFILE_V4,
    VARIANT_ON,
} from './experiments';
import { getThemeParameters } from '../theme';
import isZocdocBrand from '../../utils/isZocdocBrand';

export const getABParameters = state => state[AB_KEY];

export const isProfileV4 = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) =>
        get(ab, PROFILE_V4.experimentId, PROFILE_V4.defaultAssignment) === VARIANT_ON
        && isZocdocBrand(theme.directoryId),
);

export const showCommunityLabel = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[PROFILE_1N_COMMUNITY_LABEL_SHOWN.experimentId] === VARIANT_ON &&
        theme.profile.showCommunityLabel;
    },
);

export const showEducationYears = createSelector(
    getABParameters,
    ab => ab[PROFILE_1N_EDUCATION_YEARS_SHOWN.experimentId] === VARIANT_ON,
);

export const showInstitutes = createSelector(
    getABParameters,
    ab => ab[PROFILE_1N_INSTITUTES_SHOWN.experimentId] === VARIANT_ON,
);
